import { createContext, useContext } from 'react';

import type { SendFeedbackProps } from 'bundles/page-config-common/types/userFeedback';

export type UserFeedbackContextType = {
  sendFeedback: (feedback: SendFeedbackProps) => Promise<void>;
};

const UserFeedbackContext = createContext<UserFeedbackContextType | undefined>(undefined);

export const useUserFeedback = () => {
  const context = useContext(UserFeedbackContext);

  return {
    sendFeedback: context?.sendFeedback,
  };
};

export default UserFeedbackContext;
